// src/infrastructure/config/env.ts
// Lectura centralizada de la configuración de runtime expuesta en window._env_
// (generada por nginx/docker-entrypoint.sh desde las env vars REACT_APP_* del contenedor,
//  y por public/env_config.js en desarrollo).
var _a;
export var env = ((_a = window._env_) !== null && _a !== void 0 ? _a : {});
